import React, { FC } from 'react';

import { RumEvent } from '../common/monitoring/RumClient';
import { RegisterDomEvents, RumManager } from '../common/monitoring/RumManager';
import { GetEnvironmentConfig } from '../Environments';

export interface IRumContext {
    registerDomEvents: RegisterDomEvents
    recordEvent: (event: RumEvent) => void;
    addEvent: <T extends unknown[], R>(originalFunction: (...args: [...T]) => R, eventData: RumEvent) => (...args: [...T]) => R;
};

export const RumContext = React.createContext<IRumContext>({
    registerDomEvents: () => {},
    recordEvent: () => {},
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addEvent: function <T extends unknown[], R>(originalFunction: (...args: [...T]) => R, eventData: RumEvent): (...args: [...T]) => R {
        return originalFunction;
    }
});

export const RumContextProvider: FC = ({children}) => {
    // Enable RUM monitoring
    const { registerDomEvents, recordEvent } = RumManager(GetEnvironmentConfig());

    /**
     * Add the recordEvent function to an existing callback without having to unwrap the callback
     * allows for the original function to take in multiple parameters
     * @param originalFunction 
     * @param eventData 
     * @returns 
     */
    function addEvent<T extends unknown[], R>(originalFunction: (...args: [...T]) => R, eventData: RumEvent): (...args: [...T]) => R {
        return (...args: [...T]) => {
            recordEvent(eventData);
            return originalFunction(...args);
        };
    };

    return (
        <RumContext.Provider value={{
            registerDomEvents,
            recordEvent,
            addEvent,
        }}>
            {children}
        </RumContext.Provider>
    );
};

export default RumContext;
